"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Viewports_1 = require("../../../constants/Viewports");

var Picture =
/** @class */
function (_super) {
  __extends(Picture, _super);

  function Picture() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      viewport: utils_1.WindowEvents.getViewportSize()
    };

    _this.viewportHandler = function (viewport) {
      if (_this.props.asBackgroundImage) {
        _this.setState({
          viewport: viewport
        });
      }
    };

    _this.getFocalPoint = function () {
      if (_this.props.backgroundFocalPoint) {
        var _a = _this.props.backgroundFocalPoint,
            offsetLeft = _a.offsetLeft,
            offsetTop = _a.offsetTop;
        return "\n                    " + (offsetLeft ? "left " + offsetLeft + "%" : "") + "\n                    " + (offsetTop ? "top " + offsetTop + "%" : "") + "\n                ";
      }

      return "";
    };

    return _this;
  }

  Picture.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.viewportHandler);
  };

  Picture.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.viewportHandler);
  };

  Picture.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        alt = _a.alt,
        className = _a.className,
        children = _a.children,
        src = _a.src,
        asBackgroundImage = _a.asBackgroundImage,
        asInline = _a.asInline,
        imgWidth = _a.imgWidth,
        imgHeight = _a.imgHeight,
        maxWidth = _a.maxWidth,
        style = _a.style;
    var viewport = this.state.viewport || 'none';
    var xs = typeof src === "string" ? undefined : src.xs || src["default"];
    var sm = typeof src === "string" ? undefined : src.sm || src.xs || src["default"];
    var md = typeof src === "string" ? undefined : src.md || src.sm || src.xs || src["default"];
    var lg = typeof src === "string" ? undefined : src.lg || src.md || src.sm || src.xs || src["default"];
    var xl = typeof src === "string" ? undefined : src.xl || src.lg || src.md || src.sm || src.xs || src["default"];
    return asBackgroundImage ? React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "picture__background", className]),
      style: __assign(__assign({}, style), {
        backgroundImage: "url(" + (typeof src === "string" ? src : viewport === "xs" && xs || viewport === "sm" && sm || viewport === "md" && md || viewport === "lg" && lg || viewport === "xl" && xl || viewport === 'none' && src.none || src["default"]) + ")",
        backgroundPosition: this.getFocalPoint()
      })
    }, children) : React.createElement("picture", {
      id: id,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "picture", className, asInline && CSSPrefix_1.lsgPre + "picture__inline"]),
      style: __assign(__assign({}, style), {
        maxWidth: maxWidth
      })
    }, typeof src !== "string" ? React.createElement(React.Fragment, null, src.xl && React.createElement("source", {
      media: "(min-width: " + Viewports_1.Viewports.XL + "px)",
      srcSet: src.xl
    }), src.lg && React.createElement("source", {
      media: "(min-width: " + Viewports_1.Viewports.LG + "px)",
      srcSet: src.lg
    }), src.md && React.createElement("source", {
      media: "(min-width: " + Viewports_1.Viewports.MD + "px)",
      srcSet: src.md
    }), src.sm && React.createElement("source", {
      media: "(min-width: " + Viewports_1.Viewports.SM + "px)",
      srcSet: src.sm
    }), src.xs && React.createElement("source", {
      media: "(min-width: 0)",
      srcSet: src.xs
    }), React.createElement("img", {
      src: src["default"],
      alt: alt,
      className: CSSPrefix_1.lsgPre + "picture-img",
      height: imgHeight,
      width: imgWidth,
      style: {
        maxWidth: maxWidth
      }
    })) : React.createElement("img", {
      src: src,
      alt: alt,
      height: imgHeight,
      width: imgWidth,
      style: {
        maxWidth: maxWidth
      }
    }));
  };

  Picture.defaultProps = {
    alt: ""
  };
  return Picture;
}(React.Component);

exports.Picture = Picture;